import Component from './icon.vue'
export default Component
